const { i18n: { getLanguage } } = require('core/i18n');
const getCountryISO3 = require("country-iso-2-to-3");

/**
 * Sorts alphabetically by name but always prioritizes Spain on top.
 **/
const sortCountryNames = (countryA, countryB, firstOriginCountry) => {
    if (countryA.name === getCountryISO3(firstOriginCountry)) return -1;
    if (countryB.name === getCountryISO3(firstOriginCountry)) return 1;
    return countryA.nameLiteral.localeCompare(countryB.nameLiteral, getLanguage().toLowerCase() || 'es', {ignorePunctuation: true});
};

const sortContinentNames = (ContinentA, ContinentB) => {
    if (ContinentA.code === 'EU') return -1;
    if (ContinentB.code === 'EU') return 1;
    return ContinentA.nameLiteral.localeCompare(ContinentB.nameLiteral, getLanguage().toLowerCase() || 'es', {ignorePunctuation: true});
};


export {
    sortCountryNames,
    sortContinentNames
};
